import { ApiResponse, PaginationQuery } from '@magnetar/admin-api-interfaces'
import { IntegrationVendor } from '@magnetar/data-access'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseIntegrationVendorsParams extends PaginationQuery {
  search?: string
  isActive?: boolean
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}

export function useIntegrationVendors({
  page = 1,
  pageSize = 10,
  search,
  isActive,
  sortBy = 'created_at',
  sortOrder = 'desc',
}: UseIntegrationVendorsParams) {
  const { token } = useAuth()

  // Build query parameters
  const queryParams = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
    sortBy,
    sortOrder,
  })

  if (search) {
    queryParams.append('search', search)
  }

  if (isActive !== undefined) {
    queryParams.append('isActive', isActive.toString())
  }

  const { data, error, mutate } = useGet<
    ApiResponse<{ vendors: IntegrationVendor[]; total: number }>
  >(token ? `/api/integration-vendors?${queryParams.toString()}` : null, undefined, token ?? '')

  return {
    vendors: data?.data?.vendors,
    pagination: data?.data
      ? {
          page,
          pageSize,
          total: data.data.total,
          totalPages: Math.ceil(data.data.total / pageSize),
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
